import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { InspirationGroup } from "../models/InspirationGroupModel";



@Injectable({
  providedIn: "root"
})
export class InspirationGroupService {
  constructor(private http: HttpClient) { }

  getInspirationGroups() {
    return this.http.get<InspirationGroup[]>(`${environment.api}/api/inspirationGroup/`);
  }
}
